import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UsuarioDetalhes} from "../../../models/usuario-detalhes";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {UsuarioService} from "../../../services/usuario-service";
import Swal from "sweetalert2";
import {Token} from "../../../models/token";
import {AuthService} from "../../../services/auth-service";
import {NovaSenha} from "../../../models/nova-senha";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env/environment";
import {ItemUsuario} from "../../../models/lista-usuario";

@Component({
    selector: 'app-detalhes',
    templateUrl: './detalhes.component.html',
    styleUrl: './detalhes.component.css',
    standalone: false
})
export class DetalhesComponent {
  token: Token | undefined;
  loading = true;
  usuario = new UsuarioDetalhes();
  novaSenha = new NovaSenha();
  formAlterarDados: FormGroup;
  formAlterarSenha: FormGroup;
  id = 0;
  show = '';
  showAlterarDados = true;
  showAlterarSenha = false;
  showDetalhesConta = false;
  tipo = '';
  showInfoUsuarios = false;
  showMudarSenhaModal = false;
  secaoAtiva: 'planos' | 'usuarios' | 'ajuda' | 'senha' = 'planos';
  carregandoSecao = false;
  planoAtual: any = null;
  planosUpgrade: any[] = [];
  usuarios: ItemUsuario[] = [];
  artigosWiki: any[] = [];
  artigoWiki: any = null;
  buscaWiki = '';

  constructor(private router: Router,
              private toastr: ToastrService,
              private formBuilder: FormBuilder,
              private usuarioService: UsuarioService,
              private tokenService: AuthService,
              private route: ActivatedRoute,
              private http: HttpClient) {
    this.token = this.tokenService.AccessToken;
    this.construirFormulario();
    this.construirFormularioAlterarSenha();
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.show = params['show'];

      if(this.show == undefined || this.show == 'dados')
        this.mostrarAlterarDados();
      else if(this.show == 'senha')
        this.mostrarAlterarSenha();
      else if(this.show == 'info')
        this.mostrarDetalhes();

      if (this.id) this.buscarPorId(this.id);

      this.loading = false;
    });
    this.route.queryParamMap.subscribe(params => {
      const secao = params.get('secao');
      const secoes = ['planos', 'usuarios', 'ajuda', 'senha'];
      this.selecionarSecao((secoes.includes(secao || '') ? secao : 'planos') as 'planos' | 'usuarios' | 'ajuda' | 'senha');
    });

  }

  selecionarSecao(secao: 'planos' | 'usuarios' | 'ajuda' | 'senha') {
    this.secaoAtiva = secao;
    if (secao === 'planos') this.carregarPlanos();
    if (secao === 'usuarios') this.carregarUsuarios();
    if (secao === 'ajuda') this.carregarWiki();
  }

  private carregarPlanos() {
    this.carregandoSecao = true;
    this.http.get<any>(`${environment.apiUrl}/Portal/Plano`).subscribe({
      next: retorno => {
        this.planoAtual = retorno?.atual || null;
        this.planosUpgrade = retorno?.upgrades || [];
        this.carregandoSecao = false;
      },
      error: () => {
        this.planoAtual = null;
        this.planosUpgrade = [];
        this.carregandoSecao = false;
      }
    });
  }

  private carregarUsuarios() {
    this.carregandoSecao = true;
    this.usuarioService.selecionarLista().subscribe({
      next: retorno => {
        this.usuarios = retorno?.sucesso ? (retorno.dados?.itens || []) : [];
        this.carregandoSecao = false;
      },
      error: () => {
        this.usuarios = [];
        this.carregandoSecao = false;
      }
    });
  }

  carregarWiki() {
    this.carregandoSecao = true;
    const filtro = this.buscaWiki.trim();
    const query = filtro ? `?busca=${encodeURIComponent(filtro)}` : '';
    this.http.get<any[]>(`${environment.apiUrl}/Portal/Wiki${query}`).subscribe({
      next: retorno => {
        this.artigosWiki = retorno || [];
        this.artigoWiki = null;
        this.carregandoSecao = false;
      },
      error: () => {
        this.artigosWiki = [];
        this.artigoWiki = null;
        this.carregandoSecao = false;
      }
    });
  }

  nomeTipoUsuario(tipo: number) {
    return ({0: 'Administrador', 1: 'Gestor Administrador', 2: 'Gestor', 3: 'Assistente', 4: 'Cliente', 6: 'SDR'} as Record<number, string>)[tipo] || 'Usuário';
  }

  exibirMudarSenha() {
    this.showMudarSenhaModal = true;
    this.showInfoUsuarios = false;
  }
  resetarSenhaUsuario() {
    Swal.fire({ title: 'Enviar nova senha?', text: `Uma senha temporária será enviada para ${this.usuario.email}.`, icon: 'warning', showCancelButton: true, confirmButtonText: 'Enviar', cancelButtonText: 'Cancelar' }).then(r => {
      if (!r.isConfirmed) return;
      this.usuarioService.resetarSenha(this.id).subscribe({ next: () => this.toastr.success('Senha temporária enviada por e-mail.'), error: e => this.toastr.error(e.error || 'Não foi possível resetar a senha.') });
    });
  }

  voltar(){
    this.router.navigateByUrl('/auth/usuario');
  }

  private buscarPorId(id: number){
    this.usuarioService.buscarPorId(id).subscribe(retorno => {
      if(retorno.sucesso)
      {
        this.usuario = retorno.dados;

        switch (retorno.dados.tipoUsuario) {
          case 0:
            this.tipo = "Administrador";
            break;
          case 1:
            this.tipo = "Gestor Administrador";
            break;
          case 2:
            this.tipo = "Gestor";
            break
          case 3:
            this.tipo = "Assistente";
            break;
          case 4:
            this.tipo = "Cliente";
            break;
          case 6:
            this.tipo = "SDR";
            break;
        }
      }
      this.preencherFormulario();

    });
  }

  private construirFormulario(){
    this.formAlterarDados = this.formBuilder.group({
      nome: [this.usuario.nome, [Validators.required]],
      tipoUsuario: [this.usuario.tipoUsuario, [Validators.required]]
    });
  }

  private construirFormularioAlterarSenha(){
    this.formAlterarSenha = this.formBuilder.group({
      senhaAntiga: [this.novaSenha.senhaAntiga, [Validators.required]],
      senhaNova: [this.novaSenha.novaSenha, [Validators.required, Validators.minLength(6)]],
      confirmacaoSenha: [this.novaSenha.confirmacaoSenha, [Validators.required]]
    });
  }

  private preencherFormulario(){
    this.formAlterarDados.patchValue({
      nome: this.usuario.nome,
      tipoUsuario: this.usuario.tipoUsuario,
    });
  }
  salvarAlteracoes(){
    Swal.fire({
      title: 'Deseja realmente alterar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.preencherModelo();
        this.usuarioService.alterar(this.usuario).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Usuario alterado com sucesso");
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao alterar o cliente - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao alterar o cliente - " + error);
        });
        this.loading = false;
      }
    });
  }

  alterarSenha(){
    this.formAlterarSenha.markAllAsTouched();
    if (this.formAlterarSenha.invalid) {
      this.toastr.error('Preencha corretamente todos os campos.');
      return;
    }
    if (this.formAlterarSenha.controls['senhaNova'].value !== this.formAlterarSenha.controls['confirmacaoSenha'].value) {
      this.toastr.error('A nova senha e a confirmação não coincidem.');
      return;
    }
    Swal.fire({
      title: 'Deseja realmente alterar a senha?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.preencherModeloAlterarSenha();
        this.usuarioService.alterarSenha(this.novaSenha).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Senha alterada com sucesso");
            this.formAlterarSenha.reset();
          } else {
            this.toastr.error("Erro ao alterar a senha - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao alterar a senha - " + error);
        });
      }
      });
  }
  gerarSenha(){}

  desativar(){
    Swal.fire({
      title: 'Deseja realmente desativar usuário?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      this.loading = true;
      if(result.value) {
        this.usuarioService.desativar(this.id).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Usuário desativado com sucesso");
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao desativado o usuário - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao desativado o usuário - " + error);
        });
      }
    });
  }

  desbloquear(){
    Swal.fire({
      title: 'Deseja realmente desbloquear o usuario?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      this.loading = true;
      if(result.value) {
        this.usuarioService.desbloquear(this.id).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Usuário desbloqueado com sucesso");
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao desbloquear o usuário - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao desbloquear o usuário - " + error);
        });
      }
    });
  }

  ativar(){
    Swal.fire({
      title: 'Deseja realmente ativar o usuario?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {

      if(result.value) {
        this.loading = true;
        this.usuarioService.ativar(this.id).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Usuário ativado com sucesso");
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao ativar o usuário - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao ativar o usuário - " + error);
        });
      }
    });
  }

  preencherModeloAlterarSenha(){
    this.novaSenha.senhaAntiga = this.formAlterarSenha.controls['senhaAntiga'].value;
    this.novaSenha.novaSenha = this.formAlterarSenha.controls['senhaNova'].value;
    this.novaSenha.confirmacaoSenha = this.formAlterarSenha.controls['confirmacaoSenha'].value;
    this.novaSenha.email = this.token?.email || this.usuario.email;
  }

  preencherModelo(){
    this.usuario.tipoUsuario = this.formAlterarDados.controls['tipoUsuario'].value;
    this.usuario.nome = this.formAlterarDados.controls['nome'].value;
  }

  mostrarAlterarSenha(){
    this.showAlterarSenha = true;
    this.showDetalhesConta = false;
    this.showAlterarDados = false;
  }

  mostrarAlterarDados(){
    this.showAlterarSenha = false;
    this.showDetalhesConta = false;
    this.showAlterarDados = true;
  }

  mostrarDetalhes(){
    this.showDetalhesConta = true;
    this.showAlterarDados = false;
    this.showAlterarSenha = false;
  }

  fecharMudarSenha() {
    this.showMudarSenhaModal = false;
  }
}
